import React from "react";
import "../styles.css";

const Production = () => (
  <div className="page-container">
    <h1>Production</h1>
    <p>Under Construction</p>
  </div>
);

export default Production;
